import { BettingPoolForm } from "./BettingPoolForm";

export function CreateBettingPoolPage() {
  return <BettingPoolForm mode="create" />;
}
